import colaboradores from "./colaboradores"

export default {
	odata: {
		colaboradores
	}
}